import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { StockTakeSessionReportLineModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class StocktakeGenerateReportService extends BaseApiTemplateService<StockTakeSessionReportLineModel>{

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX +
    Core2Config.DIGI_PREFIX + 'generate-stocktake-reports/session';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX +
      Core2Config.DIGI_PREFIX + 'generate-stocktake-reports/session';
    this.endpoint_path = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.DIGI_PREFIX + 'generate-stocktake-reports/session';
    this.httpClient = theHttp;
  }

  getStocktakeReportLine(visa: ApiVisa, sessionGuid: string, update_report: boolean, active_items: boolean, appletGuid: string):
    Observable<ApiResponseModel<StockTakeSessionReportLineModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<StockTakeSessionReportLineModel>>(this.apiUrl + '/' + sessionGuid +
      '?update_report=' + update_report +
      '&active_items=' + active_items +
      '&app_hdr_guid=' + appletGuid, this.getHttpHeader(visa));
  }

}
